import { makeStyles } from "@material-ui/styles";
import React from "react";
import { remove_p_tag } from "../../helpers/Functions";

const useDisclaimerStyles = makeStyles((theme) => ({
  list: {
    margin: 0,
    padding: 0,
    "& span": {
      ...theme.typography.disclaimer,
      margin: 0
    },
    "& > span": {
      color: theme.palette.gray.main,
      display: "inline",
      "& .symbol, & .text": {
        letterSpacing: "0.06em"
      },

      "& .text:before": {
        display: "inline-block",
        content: '"|"',
        margin: "0 4px"
      }
    },
    "& > span + span .symbol": {
      marginLeft: "4px"
    }
  }
}));

function DisclaimerText({
  className,
  disclaimers_by_paragraph,
  selected_locale
}) {
  const classes = useDisclaimerStyles();
  const getDisclaimerBody = (disclaimer) => {
    const disclaimer_body = selected_locale
      ? disclaimer.getLocalized("body", selected_locale)
      : disclaimer.body;
    return remove_p_tag(disclaimer_body);
  };
  return (
    <React.Fragment>
      {disclaimers_by_paragraph.map((paragraph, paragraph_idx) => (
        <p className={classes.list} key={paragraph_idx}>
          {paragraph.map((disclaimer, disclaimer_idx) => (
            <span key={disclaimer_idx}>
              <span component="span" className="symbol">
                {disclaimer.symbol}
              </span>
              <span
                component="span"
                className="text"
                dangerouslySetInnerHTML={{
                  __html: getDisclaimerBody(disclaimer)
                }}
              />
            </span>
          ))}
        </p>
      ))}
    </React.Fragment>
  );
}

DisclaimerText.defaultProps = {
  disclaimers_by_paragraph: []
};

export default DisclaimerText;
